import { useCallback } from 'react';

import { useNavigate } from '@change-corgi/core-react/router';

import type { ShareActionsOptions, ShareChannel } from '#src/app/shared/hooks/share';

import { usePromoteOrShareActionUrls } from '../../../usePromoteOrShareActionUrls';

export function useOnShareFailure(): ShareActionsOptions['onFailure'] {
	const {
		data: { shareButtonUrl: redirectUrl },
	} = usePromoteOrShareActionUrls();
	const navigate = useNavigate();

	return useCallback(
		(channel: ShareChannel) => {
			// Only the native sheet gets this fallback, and it never navigates — a dismissed
			// `navigator.share()` leaves the page exactly where it was — so there is nothing for this
			// redirect to race, webview or not. Any other channel allowed through here needs
			// `canRedirectAfterShare` consulted first.
			if (channel !== 'mobileNativeShare') return;

			navigate(redirectUrl);
		},
		[redirectUrl, navigate],
	);
}
